import { Down as DownArrow, Up as UpArrow } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box, useTheme } from '@mui/material';

interface PercentageIconProps {
  value: number;
  toFixed?: number;
  style?: any;
}

const PercentageChange = (props: PercentageIconProps) => {
  const theme = useTheme();
  const { value } = props;

  const color = value <= 0 ? theme.palette.colors.positive[500] : theme.palette.colors.negative[500];
  const icon =
    value > 0 ? (
      <UpArrow style={{ width: '15px', height: '15px', color }} />
    ) : (
      <DownArrow style={{ width: '15px', height: '15px', color }} />
    );

  console.log('PercentageChange value', value);
  return (
    <Box sx={{ ...flex.itemsCenter, ...props.style }}>
      {icon}
      <Box sx={{ color }}> {formattedValue(value, props.toFixed)}</Box>
    </Box>
  );
};

export const formattedValue = (value, toFixed?: number) =>
  value.toFixed(toFixed ?? 2) === 'Infinity' ? 'NA' : `${value.toFixed(toFixed ?? 2)}%`;

export default PercentageChange;
